import { render, staticRenderFns } from "./DynamicComponentsTestPage.vue?vue&type=template&id=f8f1a50c&lang=pug&"
import script from "./DynamicComponentsTestPage.vue?vue&type=script&lang=js&"
export * from "./DynamicComponentsTestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports